import { merge } from 'lodash';
import ctt from '@/utils/const';

export function statChart(op, light) {
  return merge(
    {
      backgroundColor: light ? '#ffffff' : '#0c1620',
      color: ctt.CHART_COLOR,
      textStyle: {
        color: light ? '#333333' : '#00eeff'
      },
      tooltip: {
        trigger: 'axis',
        backgroundColor: light ? 'rgba(255,255,255,0.95)' : 'rgba(50,50,50,0.9)',
        borderColor: light ? '#e0e0e0' : '#333',
        textStyle: {
          color: light ? '#333' : '#fff'
        },
        position: (point, _params, _dom, _rect, size) => {
          let x = 0;
          let y = 0;

          let pointX = point[0];
          let pointY = point[1];

          let boxWidth = size.contentSize[0];
          let boxHeight = size.contentSize[1];

          if (boxWidth > pointX) {
            x = pointX + 10;
          } else {
            x = pointX - boxWidth - 10;
          }
          if (boxHeight > pointY) {
            y = 5;
          } else {
            y = pointY - boxHeight;
          }

          return [x, y];
        }
      },
      legend: {
        type: 'scroll',
        bottom: 0,
        left: 'center',
        pageTextStyle: {
          color: light ? '#333333' : '#00eeff'
        },
        textStyle: {
          color: light ? '#333333' : '#00eeff'
        }
      },
      grid: {
        containLabel: true,
        left: '10%',
        right: '12%',
        top: '14%',
        bottom: '10%'
      },
      yAxis: {
        type: 'category',
        axisLine: {
          lineStyle: {
            color: light ? '#cccccc' : '#223C90'
          }
        },
        axisLabel: {
          color: light ? '#666666' : '#00eeff'
        },
        splitLine: {
          show: false
        }
      },
      xAxis: {
        type: 'value',
        axisLine: {
          lineStyle: {
            color: light ? '#cccccc' : '#223C90'
          }
        },
        axisLabel: {
          color: light ? '#666666' : '#00eeff'
        },
        splitLine: {
          lineStyle: {
            color: light ? '#e8e8e8' : '#223C90'
          }
        }
      },
      series: []
    },
    op
  );
}
